import * as Cesium from "cesium";
import SpritelineMaterialProperty from "./material/SpritelineMaterialProperty";

const MAJOR = new Set([
  "motorway",
  "trunk",
  "primary",
  "secondary",
  "motorway_link",
  "trunk_link",
  "primary_link",
]);

/**
 * 道路飞线：只创建主干实体，不再整份 GeoJSON 二次灌进 DataSource
 */
export default class RoadLightLine {
  constructor(viewer, options = {}) {
    this.viewer = viewer;
    this.dataSource = new Cesium.CustomDataSource("道路飞线");
    viewer.dataSources.add(this.dataSource);

    const url =
      options.url ??
      `${process.env.BASE_URL}baseData/银川市道路路网_640100_GeoJSON/640100.geojson`;
    const maxCount = options.maxCount ?? 300;
    const ground = options.groundHeight ?? 1110;

    this._load(url, maxCount, ground);
  }

  async _load(url, maxCount, ground) {
    try {
      const t0 = performance.now();
      const res = await fetch(url);
      const geo = await res.json();
      const spriteline = new SpritelineMaterialProperty("roadSprite");
      let kept = 0;

      for (const f of geo.features || []) {
        if (kept >= maxCount) break;
        const fclass = f.properties?.fclass;
        if (!fclass || !MAJOR.has(fclass)) continue;

        const coords = this._lineCoords(f.geometry);
        if (!coords || coords.length < 2) continue;

        const positions = [];
        for (const c of coords) {
          positions.push(
            Cesium.Cartesian3.fromDegrees(c[0], c[1], ground + 2)
          );
        }

        this.dataSource.entities.add({
          polyline: {
            positions,
            width: 2,
            material: spriteline,
            // 自定义材质不支持 GroundPolyline，用绝对高度浮在地表上
            clampToGround: false,
          },
        });
        kept++;
      }
      console.log(
        `[RoadLightLine] 飞线 ${kept} 条 (${(performance.now() - t0).toFixed(0)}ms)`
      );
    } catch (e) {
      console.error("[RoadLightLine] 加载失败:", e);
    }
  }

  _lineCoords(geometry) {
    if (!geometry) return null;
    if (geometry.type === "LineString") return geometry.coordinates;
    if (geometry.type === "MultiLineString") {
      // 取最长一段
      let best = null;
      let bestLen = 0;
      for (const line of geometry.coordinates) {
        if (line.length > bestLen) {
          best = line;
          bestLen = line.length;
        }
      }
      return best;
    }
    return null;
  }

  setVisible(show) {
    this.dataSource.show = show;
  }
}
